import { ListCard, ListRow } from '../_ListCard'
import { useI18n } from '../_i18n'
import { useLocalePath } from '../_localePath'

// The nautical charts this station sits on, most detailed first (see
// Web::StationsController#charts_for for why it is only ever a few). Renders
// nothing where we hold no charts, which is everywhere outside US and UK
// waters.
//
// Names only. The catalog number and scale said nothing to a reader deciding
// which link to follow, and half the rows (the UK areas) have neither to show.
export default function ChartsCard({ charts = [], stationName }) {
  const { t } = useI18n()
  const localePath = useLocalePath()
  if (!charts || charts.length === 0) return null

  return (
    <ListCard title={t('charts_for_station', { name: stationName })}>
      {charts.map((chart) => (
        <ListRow
          key={chart.permalink}
          href={localePath(`/charts/${chart.permalink}`)}
          name={chart.title}
        />
      ))}
    </ListCard>
  )
}
